import { IonCard, IonCardSubtitle } from "@ionic/react";
import Page from "../components/Page";
import photo1 from "../resources/photo1.jpeg";
const Home: React.FC = () => {
  return (
    <Page title="Nicki Woods">
      <div className="w-full h-[80%] flex flex-1 text-center justify-center items-center">
        <div className="text-center justify-center h-[100%] sm:flex">
          <img
            src={photo1}
            // className="h-full w-auto -sm:w-full object-scale-down"
            style={{ borderRadius: 15 }}
            alt=""
          />

          <Table />
        </div>
      </div>
    </Page>
  );
};

export default Home;

const Table = () => {
  return (
    <div className="flex flex-1 p-[3%]">
      <table style={{ width: "100%" }} /* className="table table-striped" */>
        <tbody>
          <tr>
            <th>Model</th> <td className="pl-4">Nicki Woods</td>
          </tr>
          <tr>
            <th>Age </th> <td className="pl-4">27</td>
          </tr>
          <tr>
            <th>Height </th> <td className="pl-4">5'5 ft</td>
          </tr>
          <tr>
            <th>Weight </th> <td className="pl-4">135 lbs</td>
          </tr>
          <tr>
            <th>Cup size </th> <td className="pl-4">36D</td>
          </tr>
          <tr>
            <th>Eye color </th> <td className="pl-4">Brown</td>
          </tr>
          <tr>
            <th>Hair color </th> <td className="pl-4">Black</td>
          </tr>
          <tr>
            <th>Hair length </th> <td className="pl-4">Long</td>
          </tr>
          <tr>
            <th>Build </th>{" "}
            <td className="pl-4">All natural, beautiful face</td>
          </tr>
          <tr>
            <th>Languages </th>
            <td className="pl-4">Spanish ( fluent ), English ( fluent )</td>
          </tr>
          <tr>
            <th>Nationality </th> <td className="pl-4">Cuban</td>
          </tr>
          <tr>
            <th>Perfume </th> <td className="pl-4">Chanel</td>
          </tr>
          <tr>
            <th>Character </th>
            <td className="pl-4">
              Communicative, educated, uncomplicated, positive
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
